module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "height": "100%"
    }
  }, [(_vm.numShow) ? _c('div', {
    staticClass: "login-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "score-login-extra"
  }, [_c('van-cell-group', {
    staticClass: "score-cell"
  }, [_c('van-field', {
    attrs: {
      "name": "身份证号",
      "left-icon": require('../../../assets/images/score/login-card.png'),
      "clearable": "",
      "readonly": true,
      "placeholder": "请输入身份证号",
      "rules": [{
        required: true,
        message: '身份证号'
      }]
    },
    on: {
      "focus": _vm.onFocus
    },
    model: {
      value: (_vm.userNum),
      callback: function($$v) {
        _vm.userNum = $$v
      },
      expression: "userNum"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "score-button"
  }, [(!_vm.saveLoading) ? _c('van-button', {
    attrs: {
      "round": "",
      "block": "",
      "type": "info",
      "color": "linear-gradient(to right, #72CAF9, #2492FB)"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n            登录\n          ")]) : _c('van-button', {
    attrs: {
      "round": "",
      "block": "",
      "type": "info",
      "color": "linear-gradient(to right, #65F6D6, #0EB993)"
    }
  }, [_vm._v("\n            登录中...\n          ")])], 1)], 1)], 1)]) : _c('div', {
    staticClass: "score-box"
  }, [_c('div', {
    staticClass: "black-back"
  }, [_c('div', {
    staticClass: "score-head"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "score-title show-two-row"
  }, [_vm._v(_vm._s(_vm.apply.danwei))]), _vm._v(" "), _c('div', {
    staticClass: "score-title-child"
  }, [_vm._v(_vm._s(_vm.apply.datetitle))])]), _vm._v(" "), _c('div', {
    staticClass: "score-content"
  }, [(!_vm.scoreVisible) ? _c('div', {
    staticClass: "score-content-name flex-start"
  }, _vm._l((_vm.list2[_vm.currentIndex]), function(item, index) {
    return _c('div', {
      key: index,
      class: index == _vm.currentMemberIndex ? 'score-name-li score-name-li-active' : 'score-name-li',
      on: {
        "click": function($event) {
          return _vm.changeMember(index)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.scoreVisible) ? _c('div', {
    staticClass: "score-content-box"
  }, [_c('div', {
    staticClass: "score-content-top"
  }, [_c('div', {
    staticClass: "score-value-box"
  }, [_c('div', {
    staticClass: "score-value-text flex-between"
  }, [_c('div', {
    staticClass: "flex-start"
  }, [_c('div', {
    staticClass: "score-value-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "score-value-li"
  }, [_vm._v("分值")]), _vm._v(" "), _c('div', {
    staticClass: "score-value-li",
    staticStyle: {
      "position": "absolute",
      "right": "0.5rem"
    },
    on: {
      "click": function($event) {
        _vm.scoreVisible = false
      }
    }
  }, [_vm._v("返回"), _c('van-icon', {
    attrs: {
      "name": "revoke"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "score-value-content flex-center"
  }, [_vm._v(_vm._s(_vm.scoreValue > 0 ? _vm.scoreValue : '--'))]), _vm._v(" "), _c('div', {
    staticClass: "score-value-tip"
  }, [_vm._v(_vm._s(_vm.scoreLabel))])])]), _vm._v(" "), _c('div', {
    staticClass: "score-content-bottom flex-start",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "key-left"
  }, [_c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(1)
      }
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(2)
      }
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(3)
      }
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(4)
      }
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(5)
      }
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(6)
      }
    }
  }, [_vm._v("6")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(7)
      }
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(8)
      }
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(9)
      }
    }
  }, [_vm._v("9")]), _vm._v(" "), _c('div', {
    staticClass: "key-li-full",
    on: {
      "click": function($event) {
        return _vm.onKey(0)
      }
    }
  }, [_vm._v("0")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey('.')
      }
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "key-right"
  }, [_c('div', {
    staticClass: "key-delete flex-center",
    on: {
      "click": function($event) {
        return _vm.onKey('delete')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/score/score-delete.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "key-button flex-center",
    staticStyle: {
      "background": "#1989FA",
      "color": "#fff"
    },
    on: {
      "click": _vm.onScoreSave
    }
  }, [_vm._v("提交\n              ")])])])]) : _c('div', {
    staticClass: "score-content-box"
  }, [_c('div', {
    staticClass: "score-content-top"
  }, [_c('div', {
    staticClass: "score-value-box"
  }, [_c('div', {
    staticClass: "score-value-text flex-between"
  }, [_c('div', {
    staticClass: "flex-start"
  }, [_c('div', {
    staticClass: "score-value-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "score-value-li"
  }, [_vm._v(_vm._s(_vm.memberRow.name) + " （" + _vm._s(_vm.memberRow.grade) + "星级）")])])]), _vm._v(" "), _c('div', {
    staticClass: "score-value-ul"
  }, [_vm._v("\n                身份证 " + _vm._s(_vm.memberRow.num) + " \n              ")]), _vm._v(" "), _c('div', {
    staticClass: "score-value-ul"
  }, [_vm._v(" \n                当前考官 " + _vm._s(_vm.user.name) + "\n              ")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "score-value-ul"
  }, [_c('div', {
    staticClass: "score-value-li flex-between",
    on: {
      "click": function($event) {
        return _vm.onScoreOperate('score_fanteng', '转体')
      }
    }
  }, [_c('div', {
    staticClass: "score-value-li-left"
  }, [_vm._v("翻腾")]), _vm._v(" "), _c('div', {
    staticClass: "score-value-li-right flex-start"
  }, [_c('div', {
    staticClass: "score-value-li-text"
  }, [_vm._v(_vm._s(_vm.memberRow['score_fanteng' + (_vm.userIndex)]))]), _vm._v(" "), _c('van-icon', {
    attrs: {
      "name": "edit"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "score-value-li flex-between",
    on: {
      "click": function($event) {
        return _vm.onScoreOperate('score_zhuanti', '转体')
      }
    }
  }, [_c('div', {
    staticClass: "score-value-li-left"
  }, [_vm._v("转体")]), _vm._v(" "), _c('div', {
    staticClass: "score-value-li-right flex-start"
  }, [_c('div', {
    staticClass: "score-value-li-text"
  }, [_vm._v(_vm._s(_vm.memberRow['score_zhuanti' + (_vm.userIndex)]))]), _vm._v(" "), _c('van-icon', {
    attrs: {
      "name": "edit"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "score-value-li flex-between",
    on: {
      "click": function($event) {
        return _vm.onScoreOperate('score_tiaoyue', '跳跃')
      }
    }
  }, [_c('div', {
    staticClass: "score-value-li-left"
  }, [_vm._v("跳跃")]), _vm._v(" "), _c('div', {
    staticClass: "score-value-li-right flex-start"
  }, [_c('div', {
    staticClass: "score-value-li-text"
  }, [_vm._v(_vm._s(_vm.memberRow['score_tiaoyue' + (_vm.userIndex)]))]), _vm._v(" "), _c('van-icon', {
    attrs: {
      "name": "edit"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "score-value-li flex-between",
    on: {
      "click": function($event) {
        return _vm.onScoreOperate('score_pingheng', '平衡柔韧')
      }
    }
  }, [_c('div', {
    staticClass: "score-value-li-left"
  }, [_vm._v("平衡柔韧")]), _vm._v(" "), _c('div', {
    staticClass: "score-value-li-right flex-start"
  }, [_c('div', {
    staticClass: "score-value-li-text"
  }, [_vm._v(_vm._s(_vm.memberRow['score_pingheng' + (_vm.userIndex)]))]), _vm._v(" "), _c('van-icon', {
    attrs: {
      "name": "edit"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "score-value-li flex-between",
    on: {
      "click": function($event) {
        return _vm.onScoreOperate('score_liliang', '力量素质')
      }
    }
  }, [_c('div', {
    staticClass: "score-value-li-left"
  }, [_vm._v("力量素质")]), _vm._v(" "), _c('div', {
    staticClass: "score-value-li-right flex-start"
  }, [_c('div', {
    staticClass: "score-value-li-text"
  }, [_vm._v(_vm._s(_vm.memberRow['score_liliang' + (_vm.userIndex)]))]), _vm._v(" "), _c('van-icon', {
    attrs: {
      "name": "edit"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "score-value-li flex-between",
    on: {
      "click": function($event) {
        return _vm.onScoreOperate('score_dongzuo', '动作组合')
      }
    }
  }, [_c('div', {
    staticClass: "score-value-li-left"
  }, [_vm._v("动作组合")]), _vm._v(" "), _c('div', {
    staticClass: "score-value-li-right flex-start"
  }, [_c('div', {
    staticClass: "score-value-li-text"
  }, [_vm._v(_vm._s(_vm.memberRow['score_dongzuo' + (_vm.userIndex)]))]), _vm._v(" "), _c('van-icon', {
    attrs: {
      "name": "edit"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exame.year_type == 2),
      expression: "exame.year_type==2"
    }],
    staticClass: "score-value-li flex-between",
    on: {
      "click": function($event) {
        return _vm.onScoreOperate('score_sudu', '速度与灵敏')
      }
    }
  }, [_c('div', {
    staticClass: "score-value-li-left"
  }, [_vm._v("速度与灵敏")]), _vm._v(" "), _c('div', {
    staticClass: "score-value-li-right flex-start"
  }, [_c('div', {
    staticClass: "score-value-li-text"
  }, [_vm._v(_vm._s(_vm.memberRow['score_sudu' + (_vm.userIndex)]))]), _vm._v(" "), _c('van-icon', {
    attrs: {
      "name": "edit"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "score-value-text score-value-total flex-between"
  }, [_c('div', {
    staticClass: "flex-start"
  }, [_c('div', {
    staticClass: "score-value-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "score-value-li"
  }, [_vm._v("总分")]), _vm._v(" "), _c('div', {
    staticClass: "score-value-li-total"
  }, [_vm._v(_vm._s(_vm.memberRow.score_total))])])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-between"
  }, [_c('div', {
    staticClass: "score-caipan-button-box",
    on: {
      "click": function($event) {
        return _vm.onSubjectPrev()
      }
    }
  }, [_c('div', {
    staticClass: "score-caipan-button flex-center"
  }, [_vm._v("上一组\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "score-caipan-button-box",
    on: {
      "click": function($event) {
        return _vm.onSubjectNext()
      }
    }
  }, [_c('div', {
    staticClass: "score-caipan-button flex-center"
  }, [_vm._v("下一组\n                ")])])])])])])])]), _vm._v(" "), _c('van-number-keyboard', {
    attrs: {
      "show": _vm.keyShow,
      "extra-key": "X",
      "close-button-text": "完成"
    },
    on: {
      "close": function($event) {
        _vm.keyShow = false
      }
    },
    model: {
      value: (_vm.userNum),
      callback: function($$v) {
        _vm.userNum = $$v
      },
      expression: "userNum"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "score-login-box"
  }, [_c('div', {
    staticClass: "score-login-logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/score/login-logo.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "score-logo"
  }, [_c('div', {
    staticClass: "score-logo-box"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/score/login-logo.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "score-value-text flex-between"
  }, [_c('div', {
    staticClass: "flex-start"
  }, [_c('div', {
    staticClass: "score-value-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "score-value-li"
  }, [_vm._v("分数概览")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3459a00b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/qcxj/ExameScoreForm.vue
// module id = 2300
// module chunks = 0